<template lang="pug">
  router-view(
    v-bind:sideNavData="sideNavData"
  )
</template>
<script>
import {mapState} from "vuex";

export default {
  name: "DirectorPage",
  // data: () => ({}),
  data() {
    return {
      sideNavData: {
        links: [
          {
            path: "/pages/director/shifts",
            text: "Смены"
          }
        ]
      }
    };
  }

};
</script>
<style lang="scss" scoped></style>
